const e={a:{color:`#109FFF`,textDecoration:`none`}};export{e as DefaultEmailStyles};
//# sourceMappingURL=default-email-styles.js.map